import { memo, useEffect, useMemo, useState } from 'react';
import SideChart from './SideChart';
import SideNews from './SideNews';
import SideOrderPositions from './SideOrderPositions';
import SideDontmiss from './SideDontmiss';
import SidePlaceOrder from './SidePlaceOrder';
import SideRecommendations from './SideRecommendations';
import SideAlerts from './SideAlerts';
import SideFunds from './SideFunds';
import SideCalculators from './SideCalculators';
import SideNotes from './SideNotes';
import SideScreener from './SideScreener';
import { OPTION_CHAIN, SCRIP_INSTRUMENTS, SIDEMENU, SIDE_TRAY_EXPAND_PERCENTAGE, WATCHLIST_GRID_INDEX } from '../../../utils/global_variables';
import SideOverview from './SideOverview';
import OptionChainGrid from '../../OptionChain/OptionChainGrid';
import { useDispatch, useSelector } from 'react-redux';
import { openOptionChain, updateIsSIdeOptionChainSticked } from '../../../redux/actions/optionChain';
import { getFutureTabData } from '../../../redux/actions/marketOverview';


const SideContent = ({ setStrSideOptionOpen, sideContentId, setToggleSideContainer, isExpanded, setIsExpanded, setActiveMenu, chartUrl, scripOnExpand, sideTrayOrderEntryRef, setBIsSiderTrayOrderEntryOpen, ...props }) => {
    const scripOverviewData = useSelector(state => state?.marketOverview?.scripOverviewData);
    const arrFutureTabData = useSelector(state => state?.marketOverview?.arrFutureTabData);
    const modals = useSelector(state => state?.modals?.modals);
    const dispatch = useDispatch();
    const [chartToShow, setChartToShow] = useState(false);
    const [halfHeight, setHalfHeight] = useState(false);
    const [optionChainToShow, setOptionChainToShow] = useState(false);
    const [chartExpand, setChartExpand] = useState(false);
    const [syncWatchlist, setSyncWatchlist] = useState(false);
    const bIsFutureAndOptionTab = useMemo(() => (arrFutureTabData?.length > 0 && scripOverviewData?.length > 0 && !scripOverviewData?.[WATCHLIST_GRID_INDEX?.INSTRUMENT]?.includes("UND"))
        || (scripOverviewData?.[WATCHLIST_GRID_INDEX?.IS_FO_EXIST] !== 0 && scripOverviewData?.[WATCHLIST_GRID_INDEX?.NSPREAD] === 0)
        , [scripOverviewData, arrFutureTabData]);
    useEffect(()=>{
        if(sideContentId!==SIDEMENU.SIDE_OVERVIEW){
            setStrSideOptionOpen(false);
        }
    },[sideContentId])
    useEffect(() => {
        dispatch(updateIsSIdeOptionChainSticked(optionChainToShow));
    }, [optionChainToShow, dispatch]);
    useEffect(() => {
        dispatch(getFutureTabData({ symbol: scripOverviewData?.[WATCHLIST_GRID_INDEX.SYMBOL], instrument: scripOverviewData?.[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES ? SCRIP_INSTRUMENTS.FUTSTK : scripOverviewData?.[WATCHLIST_GRID_INDEX.INSTRUMENT] }));
    }, [scripOverviewData]);
    useEffect(() => {
        if (optionChainToShow && bIsFutureAndOptionTab) {
            dispatch(openOptionChain({
                expiryDate: scripOverviewData[WATCHLIST_GRID_INDEX?.EXPIRYDATE],
                instrumentName: scripOverviewData[WATCHLIST_GRID_INDEX.INSTRUMENT],
                symbol: scripOverviewData[WATCHLIST_GRID_INDEX.SYMBOL], instrument: scripOverviewData[WATCHLIST_GRID_INDEX.INSTRUMENT],
                id: scripOverviewData[WATCHLIST_GRID_INDEX?.SEGMENT_ID],
                token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
                bestFive: true,
                location: OPTION_CHAIN.SIDE_OVERVIEW,
                mappedId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                assetToken: scripOverviewData[WATCHLIST_GRID_INDEX.ASSET_TOKEN] !== 0 ? scripOverviewData[WATCHLIST_GRID_INDEX.ASSET_TOKEN] : scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN]
            }));
            setHalfHeight(true)
        }
    }, [optionChainToShow, scripOverviewData, chartToShow]);
    useEffect(() => {
        if (!bIsFutureAndOptionTab && optionChainToShow) {
            setHalfHeight(!halfHeight);
            if (!chartToShow && !optionChainToShow) {
                setIsExpanded(prevState => { return { ...prevState, isTrue: !prevState?.isTrue, containerLength: prevState?.isTrue ? SIDE_TRAY_EXPAND_PERCENTAGE?.TWENTY_FIVE_PERCENT : SIDE_TRAY_EXPAND_PERCENTAGE?.SEVENTY_FIVE_PERCENT }; });
            }
        }
    }, [bIsFutureAndOptionTab]);
    useEffect(() => {
        if (optionChainToShow && bIsFutureAndOptionTab && modals['ORDER_ENTRY_MODAL']) {
            dispatch(openOptionChain({
                expiryDate: scripOverviewData[WATCHLIST_GRID_INDEX?.EXPIRYDATE],
                instrumentName: scripOverviewData[WATCHLIST_GRID_INDEX.INSTRUMENT],
                symbol: scripOverviewData[WATCHLIST_GRID_INDEX.SYMBOL], instrument: scripOverviewData[WATCHLIST_GRID_INDEX.INSTRUMENT],
                id: scripOverviewData[WATCHLIST_GRID_INDEX?.SEGMENT_ID],
                token: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
                bestFive: true,
                location: OPTION_CHAIN.SIDE_OVERVIEW,
                mappedId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                assetToken: scripOverviewData[WATCHLIST_GRID_INDEX.ASSET_TOKEN] !== 0 ? scripOverviewData[WATCHLIST_GRID_INDEX.ASSET_TOKEN] : scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN]
            }));
        }
    }, [modals['ORDER_ENTRY_MODAL']]);
    const handleOptionChain = () => {
        setOptionChainToShow(!optionChainToShow);
    };
    const handleChart = () => {
        //vaibhav Singh: code commented for furthere development
        setChartToShow(!chartToShow);

    };
    const handleOptionAndChart = (each) => {
        if (each?.option) {
            setOptionChainToShow(!optionChainToShow);
            setStrSideOptionOpen(!optionChainToShow);
            if (chartToShow) {
                setHalfHeight(!halfHeight);
            } else {
                setIsExpanded(prevState => { return { ...prevState, isTrue: !prevState?.isTrue, containerLength: prevState?.isTrue ? SIDE_TRAY_EXPAND_PERCENTAGE?.TWENTY_FIVE_PERCENT : SIDE_TRAY_EXPAND_PERCENTAGE?.SEVENTY_FIVE_PERCENT }; });
            }
        }
        if (each?.chart) {
            setChartToShow(!chartToShow);
            if (optionChainToShow) {
                setHalfHeight(!halfHeight);
            } else {
                setIsExpanded(prevState => { return { ...prevState, isTrue: !prevState?.isTrue, containerLength: prevState?.isTrue ? SIDE_TRAY_EXPAND_PERCENTAGE?.TWENTY_FIVE_PERCENT : SIDE_TRAY_EXPAND_PERCENTAGE?.SEVENTY_FIVE_PERCENT }; });
            }
        }
    };
    switch (sideContentId) {

        case SIDEMENU.ORDER_TICKET: {
            return (
                //BT- 112339:Watchlist||Side Tray | Closing functionality: ManasaB: 30/06/23 Added setActiveMenu.. Start
                <div className={`sticky-sidemenu-container ${isExpanded?.isTrue ? 'sidemenu-container-half' : 'sidemenu-container-quarter'}`}>
                    <SidePlaceOrder ref={sideTrayOrderEntryRef} setIsExpanded={setIsExpanded} setToggleSideContainer={setToggleSideContainer} setActiveMenu={setActiveMenu} setBIsSiderTrayOrderEntryOpen={setBIsSiderTrayOrderEntryOpen} />
                </div>
            );
        }
        case SIDEMENU.CHART: {
            return (<div className={`sticky-sidemenu-container ${isExpanded?.isTrue ? 'sidemenu-container-full' : 'sidemenu-container-half'}`}>
                <SideChart scripOnExpand={scripOnExpand} setToggleSideContainer={setToggleSideContainer} setIsExpanded={setIsExpanded} isExpanded={isExpanded} chartUrl={chartUrl} setActiveMenu={setActiveMenu} />
            </div>);
        }
        case SIDEMENU.SCREENER: {
            return (
                <div className={`sticky-sidemenu-container ${isExpanded?.isTrue ? 'sidemenu-container-full' : 'sidemenu-container-quarter'}`}>
                    <SideScreener setToggleSideContainer={setToggleSideContainer} isExpanded={isExpanded} setIsExpanded={setIsExpanded} setActiveMenu={setActiveMenu} />
                </div>
            );
        }
        case SIDEMENU.RECOMMENDATIONS: {
            return (
                <div className={`sticky-sidemenu-container ${isExpanded?.isTrue ? 'sidemenu-container-half' : 'sidemenu-container-quarter'}`}>
                    <SideRecommendations setIsExpanded={setIsExpanded} sideContentId={sideContentId} setToggleSideContainer={setToggleSideContainer} setActiveMenu={setActiveMenu} />
                </div>
            );
        }
        case SIDEMENU.NEWS_EVENTS: {
            return (
                <div className={`sticky-sidemenu-container ${isExpanded?.isTrue ? 'sidemenu-container-half' : 'sidemenu-container-quarter'}`}>
                    <SideNews sideContentId={sideContentId} setToggleSideContainer={setToggleSideContainer} isExpanded={isExpanded} setIsExpanded={setIsExpanded} setActiveMenu={setActiveMenu} />
                </div>
            );
        }
        case SIDEMENU.DONT_MISS: {
            return (
                <div className={`sticky-sidemenu-container ${isExpanded?.isTrue ? 'sidemenu-container-half' : 'sidemenu-container-quarter'}`}>
                    <SideDontmiss setIsExpanded={setIsExpanded} setToggleSideContainer={setToggleSideContainer} sideContentId={sideContentId} setActiveMenu={setActiveMenu} />
                </div>
            );
        }
        case SIDEMENU.ORDERS_POSITIONS: {
            return (
                <div className={`sticky-sidemenu-container ${isExpanded?.isTrue ? 'sidemenu-container-half' : 'sidemenu-container-quarter'}`}>
                    <SideOrderPositions setIsExpanded={setIsExpanded} setToggleSideContainer={setToggleSideContainer} setActiveMenu={setActiveMenu} />
                </div>
            );
        }
        case SIDEMENU.FUNDS: {
            return (
                <div className={`sticky-sidemenu-container ${isExpanded?.isTrue ? 'sidemenu-container-half' : 'sidemenu-container-quarter'}`}>
                    <SideFunds setIsExpanded={setIsExpanded} setToggleSideContainer={setToggleSideContainer} sideContentId={sideContentId} setActiveMenu={setActiveMenu} />
                </div>
            );
        }
        case SIDEMENU.ALERTS_NOTIFICATIONS: {
            return (
                <div className={`sticky-sidemenu-container ${isExpanded?.isTrue ? 'sidemenu-container-half' : 'sidemenu-container-quarter'}`}>
                    <SideAlerts setIsExpanded={setIsExpanded} sideContentId={sideContentId}
                        setToggleSideContainer={setToggleSideContainer} setActiveMenu={setActiveMenu} />
                </div>
            );
        }
        case SIDEMENU.CALCULATORS: {
            return (
                <div className={`sticky-sidemenu-container ${isExpanded?.isTrue ? 'sidemenu-container-half' : 'sidemenu-container-quarter'}`}>
                    <SideCalculators setIsExpanded={setIsExpanded} sideContentId={sideContentId} setToggleSideContainer={setToggleSideContainer} setActiveMenu={setActiveMenu} />
                </div>
            );
        }
        case SIDEMENU.WRITE_SAVE_NOTES: {
            return (
                <div className={`sticky-sidemenu-container ${isExpanded?.isTrue ? 'sidemenu-container-half' : 'sidemenu-container-quarter'}`}>
                    <SideNotes setIsExpanded={setIsExpanded} sideContentId={sideContentId}
                        setToggleSideContainer={setToggleSideContainer} setActiveMenu={setActiveMenu} />
                </div>
            );
        }
        case SIDEMENU.OVERVIEW: {
            return (
                <>
                    {(chartToShow && optionChainToShow) ?
                        <>
                            <div className={`sticky-sidemenu-container ${!chartExpand ? 'side-overview-main-wrapper m-r-25' : 'sidemenu-container-full'}`}>
                                <SideChart halfHeight={halfHeight} sideTraySync={syncWatchlist} setSideTraySync={setSyncWatchlist} scripOnExpand={scripOnExpand} setChartExpand={setChartExpand} chartExpand={chartExpand} isVertical={false} setToggleSideContainer={setToggleSideContainer} setIsExpanded={setIsExpanded} isExpanded={isExpanded} chartUrl={chartUrl} setActiveMenu={setActiveMenu} />
                                {bIsFutureAndOptionTab? <OptionChainGrid halfHeight={halfHeight} sideOverview={true} />:null}
                            </div>
                        </>
                        : null
                    }
                    {(chartToShow && !optionChainToShow) ?
                        <div className={`sticky-sidemenu-container ${!chartExpand ? 'side-overview-main-wrapper m-r-25' : 'sidemenu-container-full'}`}>
                            <SideChart sideTraySync={syncWatchlist} setSideTraySync={setSyncWatchlist} scripOnExpand={scripOnExpand} setChartExpand={setChartExpand} chartExpand={chartExpand} isVertical={false} setToggleSideContainer={setToggleSideContainer} setIsExpanded={setIsExpanded} isExpanded={isExpanded} chartUrl={chartUrl} setActiveMenu={setActiveMenu} />
                        </div>
                        : null
                    }
                    {(optionChainToShow && !chartToShow) ?
                        <div className={'sticky-sidemenu-container side-overview-main-wrapper m-r-25'}>
                            {bIsFutureAndOptionTab?<OptionChainGrid sideOverview={true} />:null}
                        </div>
                        :
                        null
                    }
                    {(!chartExpand) ?
                        <div className={`sticky-sidemenu-container sidemenu-container-quarter`}>
                            <SideOverview bIsFutureAndOptionTab={bIsFutureAndOptionTab} handleOptionAndChart={handleOptionAndChart} syncWatchlist={syncWatchlist} setSyncWatchlist={setSyncWatchlist} optionChainToShow={optionChainToShow} handleOptionChain={handleOptionChain} handleChart={handleChart} chartToShow={chartToShow} scripOnExpand={scripOnExpand} sideContentId={sideContentId} chartUrl={chartUrl} setToggleSideContainer={setToggleSideContainer} isExpanded={isExpanded} setIsExpanded={setIsExpanded} setActiveMenu={setActiveMenu} />
                        </div>
                        : null}
                </>
            );
        }
        //BT- 112339:Watchlist||Side Tray | Closing functionality: ManasaB: 30/06/23 Added setActiveMenu..End
        default: { return null; }
    }
};

export default memo(SideContent);